/** Shared content roles, based on Dashboard's compact visual hierarchy. */
export const contentTypography = {
  pageTitle: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: 1.3,
    overflowWrap: 'anywhere',
  },
  cardTitle: {
    fontWeight: 700,
  },
  primary: {
    fontWeight: 600,
  },
  metric: {
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 1.15,
  },
} as const;

export const contentSpacing = {
  gutter: 2,
  headerY: 1,
  rowY: 0.5,
  textGap: 0.5,
  sectionGap: 2,
} as const;
